import { NotificationType } from '@weave/schema-gen-ts/dist/shared/notification/notifications.pb';
import { PreferenceDict } from './types';
/**
 * This file contains the default values for user preferences in the application.
 */

const defaultFilterValues = [
  NotificationType.SMS,
  NotificationType.SCHEDULE_REQUEST,
  NotificationType.PAYMENTS,
  NotificationType.CALL_RECORD_TAG,
  NotificationType.FAX_TAG,
  NotificationType.SMS_TAG_V2,
  NotificationType.VOICEMAIL_TAG,
  'TAGS' as NotificationType,
];

export const DEFAULT_PREFERENCES: Partial<PreferenceDict> = {
  ForYouNotificationFilters: defaultFilterValues,
  PaymentsReceiptSettingsBannerDismissed: false,
  // Add more keys as we grow...
};
